import { compact, uniq } from "lodash";

export function formatList(list) {
  const sanitizedList = compact(uniq(list));
  return sanitizedList.length > 0 ? sanitizedList.join(", ") : "None";
}
